import { render, staticRenderFns } from "./MensagemTeclado.vue?vue&type=template&id=54ba5755&scoped=true&"
import script from "./MensagemTeclado.vue?vue&type=script&lang=js&"
export * from "./MensagemTeclado.vue?vue&type=script&lang=js&"
import style0 from "./MensagemTeclado.vue?vue&type=style&index=0&id=54ba5755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba5755",
  null
  
)

export default component.exports